import React from 'react'
import styles from './NavBar.module.css'
import { NAV_LINKS } from '@/constants'
import { cn } from '@/utils'
import { useScrolled } from '@/hooks'

interface NavBarProps {
  mobileOpen:    boolean
  onMobileClose: () => void
}

const NavBar: React.FC<NavBarProps> = ({ mobileOpen, onMobileClose }) => {
  const scrolled = useScrolled(10)

  return (
    <>
      {/* Desktop Navigation */}
      <nav
        className={cn(styles.navBar, scrolled && styles['navBar--scrolled'])}
        aria-label="Primary navigation"
      >
        <div className={styles.navBar__inner}>
          <ul className={styles.navBar__links} role="list">
            {NAV_LINKS.map((link) => (
              <li key={link.id}>
                <a
                  href={link.href}
                  className={cn(
                    styles.navBar__link,
                    link.id === 'book-home' && styles['navBar__link--cta']
                  )}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div
        className={cn(styles.mobileDrawer, mobileOpen && styles['mobileDrawer--open'])}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation menu"
      >
        <div
          className={styles.mobileDrawer__overlay}
          onClick={onMobileClose}
          aria-hidden="true"
        />
        <div className={styles.mobileDrawer__panel}>
          <div className={styles.mobileDrawer__header}>
            <span className={styles.mobileDrawer__title}>Nextgen Health</span>
            <button
              className={styles.mobileDrawer__close}
              onClick={onMobileClose}
              aria-label="Close navigation menu"
            >
              ✕
            </button>
          </div>
          <nav className={styles.mobileDrawer__links} aria-label="Mobile primary navigation">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className={styles.mobileDrawer__link}
                onClick={onMobileClose}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </>
  )
}

export default NavBar

